/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

/**
      * RoleActivationState describes whether a role is effective or still
pending delayed activation. Terminal pending requests (cancelled, or
completed and visible as an ordinary effective role) are not reported as
pending states.

 - ROLE_ACTIVATION_STATE_UNSPECIFIED: Unknown or not reported (e.g. a server that predates delayed
activation). Clients must not infer access from this value.
 - ROLE_ACTIVATION_STATE_EFFECTIVE: The role is granted and effective.
 - ROLE_ACTIVATION_STATE_SCHEDULED: A pending request exists and its scheduled effective_at is in the
future. This request has not granted the role.
 - ROLE_ACTIVATION_STATE_AWAITING_GRANT: effective_at has passed and this request has not confirmed the grant
(for example worker lag, a grant in progress, or the grantee has not
accepted the invitation). Do not infer access either way from this
state; the effective role list is authoritative.
 - ROLE_ACTIVATION_STATE_CANCELLATION_PENDING: Cancellation was requested and in-flight work has not settled. The
outcome is uncertain: an activation already in progress may still
complete, in which case the role is removed through the ordinary
role-removal path. Do not infer access either way from this state;
the effective role list is authoritative.
      * @Example No example provided
      */
export enum CoinbaseEngUsersAccountManagementApiApiRoleActivationState {
  ROLE_ACTIVATION_STATE_UNSPECIFIED = 'ROLE_ACTIVATION_STATE_UNSPECIFIED',
  ROLE_ACTIVATION_STATE_EFFECTIVE = 'ROLE_ACTIVATION_STATE_EFFECTIVE',
  ROLE_ACTIVATION_STATE_SCHEDULED = 'ROLE_ACTIVATION_STATE_SCHEDULED',
  ROLE_ACTIVATION_STATE_AWAITING_GRANT = 'ROLE_ACTIVATION_STATE_AWAITING_GRANT',
  ROLE_ACTIVATION_STATE_CANCELLATION_PENDING = 'ROLE_ACTIVATION_STATE_CANCELLATION_PENDING',
}
export const getCoinbaseEngUsersAccountManagementApiApiRoleActivationStateErrors = (
  value: unknown,
): { fieldName: string; error: string }[] => {
  if (process.env.NODE_ENV === 'production') return [];
  if (
    !Object.values(CoinbaseEngUsersAccountManagementApiApiRoleActivationState).includes(
      value as any,
    )
  ) {
    return [
      {
        fieldName: '',
        error: ` ${value} is not a valid CoinbaseEngUsersAccountManagementApiApiRoleActivationState.`,
      },
    ];
  } else {
    return [];
  }
};

const validateCoinbaseEngUsersAccountManagementApiApiRoleActivationState = (value: unknown) => {
  const errors = getCoinbaseEngUsersAccountManagementApiApiRoleActivationStateErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: CoinbaseEngUsersAccountManagementApiApiRoleActivationState data does not match contract.`,
      errors,
    );
  }
};
